import React from "react";
import { editPostPath } from "../../../../../../routes";
import { PostsShowProps } from "../../../../posts/lib/types";
import { SharedCurrentUser } from "../../../lib/types";
import { Box, Flex } from "@chakra-ui/react";
import BookmarkButton from "../BookmarkButton";
import ModeEditIcon from "../../icons/ModeEditIcon";

export const Actions = ({ post, currentUser }: { post: PostsShowProps; currentUser: SharedCurrentUser }) => {
  return (
    <Flex justifyContent="flex-end" gap={{ base: 1, md: 2 }} alignItems="center">
      <BookmarkButton post_code={post.code} bookmarked={post.is_bookmarked} currentUser={currentUser} />
      {!post.is_resolved && post.is_own && (
        <Box
          as="a"
          display="flex"
          color="primary"
          boxSize={10}
          justifyContent="center"
          alignItems="center"
          cursor="pointer"
          _hover={{
            bgColor: "#EDF5F3",
          }}
          rounded="full"
          href={editPostPath(post.code)}
          aria-label="投稿を編集"
        >
          <ModeEditIcon boxSize={6} />
        </Box>
      )}
    </Flex>
  );
};
